'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/app/store';
import { fetchBranding } from '@/app/store/thunks/brandingThunks';

/**
 * Dispatches `fetchBranding` once on mount to hydrate the branding slice
 * from `/api/config/get-main_config`. Components that need to render the
 * current brand read it via the `useBranding()` hook.
 *
 * NOTE: This provider intentionally does NOT override `document.title` —
 * per-page Next.js metadata titles ("API Keys - Smart Matrix Admin") would
 * be clobbered on every branding-state change. If a future spec wants
 * dynamic per-page titles that include the operator brand, use Next.js
 * `generateMetadata` with a server-side branding fetch.
 */
const BrandingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBranding());
  }, [dispatch]);

  return <>{children}</>;
};

export default BrandingProvider;
